const animals = {
  name: "Animals",
  prompts: [
    "Lion",
    "Crocodile",
    "Rabbit",
    "Armadillo",
    "Elephant",
    "Alligator",
    "Fox",
    "Camel",
    "Peacock",
    "Tiger",
    "Snake",
    "Deer",
    "Horse",
    "Hummingbird",
    "Giraffe",
    "Lizard",
    "Moose",
    "Cow",
    "Zebra",
    "Turtle",
    "Wolf",
    "Sheep",
    "Cheetah",
    "Frog",
    "Coyote",
    "Goat",
    "Rattlesnake",
    "Panda",
    "Toad",
    "Raccoon",
    "Pig",
    "Cobra",
    "Kangaroo",
    "Salamander",
    "Skunk",
    "Chicken",
    "Anaconda",
    "Koala",
    "Octopus",
    "Otter",
    "Duck",
    "Python",
    "Gorilla",
    "Jellyfish",
    "Hedgehog",
    "Turkey",
    "Hippopotamus",
    "Seahorse",
    "Mole",
    "Eagle",
    "Kingfisher",
    "Rhinoceros",
    "Lobster",
    "Platypus",
    "Hawk",
    "Starfish",
    "Polar bear",
    "Crab",
    "Koala",
    "Falcon",
    "Clam",
    "Grizzly bear",
    "Butterfly",
    "Tasmanian Devil",
    "Owl",
    "Dolphin",
    "Chimpanzee",
    "Bee",
    "Dingo",
    "Parrot",
    "Otter",
    "Dolphin",
    "Ant",
    "Chimpanzee",
    "Penguin",
    "Whale",
    "Whale",
    "Spider",
    "Gorilla",
    "Sparrow",
    "Shark",
    "Scorpion",
    "Orangutan",
    "Pigeon",
    "Stingray",
    "Penguin",
    "Bat",
    "Lemur",
    "Swan",
    "Eel",
    "Ostrich",
    "Squirrel",
    "Sloth",
    "Flamingo",
    "Goldfish",
  ],
};

export default animals;
